import { AutogenModelFreightMatchingProfileDataOutput, AutogenRowFreightMatchingProfileDataOutput } from "./autogen/AutogenModelFreightMatchingProfileDataOutput";

export class ModelFreightMatchingProfileDataOutput extends AutogenModelFreightMatchingProfileDataOutput<RowFreightMatchingProfileDataOutput> {
	constructor() {
		super(RowFreightMatchingProfileDataOutput);
	}
}

export class RowFreightMatchingProfileDataOutput extends AutogenRowFreightMatchingProfileDataOutput {
}